import { NavLink, Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { useAuth } from '../../context/AuthContext';
import { Contenedor, TituloPagina } from '../../components/layout/Layout';

const Pestanas = styled.nav`
  display: flex;
  gap: ${({ theme }) => theme.space.xs};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  margin-bottom: ${({ theme }) => theme.space.xl};
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

const Pestana = styled(NavLink)`
  padding: 0.7rem 1rem;
  font-size: 0.92rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textMuted};
  border-bottom: 2px solid transparent;
  white-space: nowrap;
  transition: color 200ms ease;

  &:hover {
    color: ${({ theme }) => theme.colors.text};
  }

  &.active {
    color: ${({ theme }) => theme.colors.sageDeep};
    border-bottom-color: ${({ theme }) => theme.colors.sage};
  }
`;

function CuentaLayout() {
  const { usuario } = useAuth();

  return (
    <Contenedor>
      <TituloPagina>Hola, {usuario.nombre.split(' ')[0]}</TituloPagina>
      <Pestanas>
        <Pestana to="/mi-cuenta/reservas">Próximas clases</Pestana>
        <Pestana to="/mi-cuenta/historial">Historial</Pestana>
        <Pestana to="/mi-cuenta/paquete">Mi paquete</Pestana>
        <Pestana to="/mi-cuenta/perfil">Perfil</Pestana>
      </Pestanas>
      <Outlet />
    </Contenedor>
  );
}

export default CuentaLayout;
